import React from 'react'

const LaserLightbox = () => {
  return (
    <div className='lightbox__paragraph'>
    <h1>Intense Pulsed Light (IPL)</h1>
    <br />
    <ul>
      <li>• Redness, Rosacea & Facial Veins </li>
      <li>• Brown Spots & Discolouration</li>
      <li>• Acne</li>
      <li>• Hair Removal</li>
    </ul>
    <br />
    <h1>PicoSure Pro&#174;</h1>
    <br />
    <ul>
      <li>• Pigmentation/Brown Spots</li>
      <li>• Melasma</li>
      <li>• Fine Lines & Wrinkles</li>
      <li>• Skin Texture and Tone</li>
      <li>• Englarged Pores</li>
      <li>• Acne Scars</li>
      <li>• Tattoo Removal</li>
    </ul>
    <br />
    <h1>Potenza&#174; RF Microneedling</h1>
    <br />
    <ul>
      <li>• Collagen Induction Therapy</li>
      <li>• Fine Lines & Wrinkles</li>
      <li>• Skin Laxity</li>
      <li>• Acne Scarring</li>
      <li>• Post-Traumatic, Surgical Scarring</li>
    </ul>
    <br />
    <h1>Icon&#174; Non-Ablative Fractional Laser</h1>
    <br />
    <ul>
      <li>• Fine Lines and Wrinkles</li>
      <li>• Sun Damage</li>
      <li>• Skin Resurfacing</li>
      <li>• Acne Scarring</li>
      <li>• Stretch Marks</li>
    </ul>
    <br />
    <h1>TempSure&#174;, FlexSure&#174;</h1>
    <br />
    <ul>
      <li>• Fine Lines and Wrinkles</li>
      <li>• Skin Tightening for Face & Body</li>
    </ul>
    <br />
    <h1>SculpSure&#174;</h1>
    <br />
    <ul>
      <li>• Non-Invasive Body Contouring</li>
      <li>• Double Chin Treatment</li>
    </ul>
    <br />
    <p>
    These advanced medical technologies deliver non-invasive treatments that target sun damage, improve skin texture and wrinkles, diminish redness and pigmentation. Skin tightening, acne scarring, hair removal and body contouring are other concerns that can be addressed.
    </p>
    </div>
  )
}

export default LaserLightbox
